<template>
  <aside v-if="appliesToOffer" class="service-contract-notice" :aria-label="$t('legal.serviceContractHeading')">
    <h5 class="service-contract-notice__heading">
      <svg class="service-contract-notice__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v6" />
        <circle cx="12" cy="7.5" r="0.75" fill="currentColor" stroke="none" />
      </svg>
      {{ $t('legal.serviceContractHeading') }}
    </h5>
    <p>{{ $t('legal.serviceContract') }}</p>
  </aside>
</template>

<script>
export default {
  name: 'ServiceContractNotice',
  props: {
    offerTypeId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    appliesToOffer() {
      return [1, 2, 3].includes(this.offerTypeId);
    },
  },
};
</script>

<style scoped>
.service-contract-notice {
  margin: 0 0 2rem;
  padding: 0.125rem 0 0.125rem 1.375rem;
  border-left: 2px solid #50bcbc;
  break-inside: avoid;
  page-break-inside: avoid;
}

.service-contract-notice__heading {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.5rem;
  font-size: 1em;
  font-weight: 600;
  line-height: 1.5;
}

.service-contract-notice__icon {
  width: 1.125rem;
  height: 1.125rem;
  flex: none;
  color: #1f9191;
  stroke: currentColor;
  stroke-width: 1.5;
  stroke-linecap: round;
}

.service-contract-notice p {
  margin: 0;
  line-height: 1.65;
}
</style>
